import React, { useMemo } from 'react';
import { Play } from 'lucide-react';
import { useSpineRuntimeStore } from '../../../store/spineStore';

interface SpineAnimationPickerProps {
  value: string;
  spineAssetId: string | null;
  onChange: (animationName: string) => void;
  disabled?: boolean;
}

export const SpineAnimationPicker: React.FC<SpineAnimationPickerProps> = ({
  value,
  spineAssetId,
  onChange,
  disabled = false,
}) => {
  const loadedAssets = useSpineRuntimeStore((s) => s.loadedAssets);

  const animations = useMemo(() => {
    if (!spineAssetId || !loadedAssets[spineAssetId]) {
      return [];
    }
    return loadedAssets[spineAssetId].animations;
  }, [spineAssetId, loadedAssets]);

  return (
    <div className="flex items-center gap-2">
      <Play className="w-4 h-4 text-green-400 flex-shrink-0" />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || !spineAssetId}
        className="flex-1 bg-zinc-800 border border-zinc-700 rounded px-2 py-1 text-sm text-zinc-200 disabled:opacity-50"
      >
        <option value="">None</option>
        {animations.map((anim) => (
          <option key={anim.name} value={anim.name}>
            {anim.name} ({anim.duration.toFixed(2)}s)
          </option>
        ))}
      </select>
    </div>
  );
};
